// eslint-env es6
import moment from 'moment';
import { tz, utc } from 'moment-timezone';


export const FORMAT_DATE = 'YYYY-MM-DD';
export const FORMAT_TIME = 'HH:mm:ss';
export const FORMAT_UI_DATE = 'MMM D, YYYY';
export const FORMAT_UI_DATE_TIME = 'HH:mm - MMM D, YYYY';

// eslint-disable-next-line import/prefer-default-export
export const TimeUtil = {
  FORMAT_DATE,
  FORMAT_TIME,
  FORMAT_UI_DATE,
  FORMAT_UI_DATE_TIME,

  setMomentLocale(locale) {
    moment.locale(locale);
  },
  getLocale() {
    return moment.locale();
  },
  now() {
    return moment();
  },
  nowUtc() {
    return utc();
  },
  getTimezone() {
    return tz.guess();
  },
};

/**
 * Convert a date format string to a moment object.
 * @param {*} date
 * @param {string|null} timezone
 */
export function fromDateStrToMoment(date) {
  const m = moment(date, FORMAT_DATE, true);
  if (!m.isValid()) {
    const message = `
      The given date string is not in the correct format.
      Expected format: YYYY-MM-DD, received ${date}`;
    throw message.trim();
  }

  return m;
}

/**
 * Get a moment object with the current time.
 */
export function now() {
  return moment();
}
